import { DateTime } from 'luxon';
import cx from 'classnames';

import {
  BtnLevel,
  BtnType,
  Icon,
  IconEnum,
  bdcCGV1,
  bdcCGV2,
  bdcCGV3,
  bdcCGV4,
  bdcCGV5,
  bdcCGV6,
  bdcCGV7,
  gekaLogoGreen_nobg_png,
  kit_bdcCGV1,
  kit_bdcCGV2,
  kit_bdcCGV3,
  kit_bdcCGV4,
} from '@greenkub-fronts/shared/ui';
import { GKToggleableInput, Button } from '@greenkub-fronts/shared/ui';
import { formatCurrency } from '@greenkub-fronts/shared/utils';
import {
  Address,
  ArraySignatures,
  FixMe,
  Project,
} from '@greenkub-fronts/shared/interface';

import mainStyles
  from '../../document-signature-container/document-signature-container.module.scss';
import templateStyles from '../base-template.module.scss';
import styles from './../bdc/bdc.module.scss';
import { AddressPdfBloc } from '../address/addressPdfBloc';

export interface AmendmentProps {
  isSignature: boolean;
  signature: string;
  signatures: ArraySignatures;
  handleOpenModalSignHandler: (index: number) => void;
  sign1Ref: FixMe;
  sign2Ref: FixMe;
  triggerUpsells: () => void;
  itemPages: [[]];
  project: Project;
  isKit: boolean;
  address: Address;
  totalPrice: number;
  adjustment: number;
  updateAdjustment: (e: FixMe) => void;
  comment: string;

  totalVatAdjusted: number;
  totalPriceWithVatAdjusted: number;
  setComment: (e: FixMe) => void;
  paginatedBDCAfterAvenant: FixMe;
  bdcAfterAvenant: FixMe;
  projectAdjustment: number;
  totalProjectVatAdjusted: number;
  totalPriceProjectWithVatAdjusted: number;
}

const Amendment = (props: AmendmentProps) => {
  const {
    isSignature,
    signature,
    signatures,
    handleOpenModalSignHandler,
    sign1Ref,
    sign2Ref,
    triggerUpsells,
    itemPages,
    project,
    isKit,
    address,
    totalPrice,
    adjustment,
    updateAdjustment,
    comment,
    totalVatAdjusted,
    totalPriceWithVatAdjusted,
    setComment,
    paginatedBDCAfterAvenant,
    bdcAfterAvenant,
    projectAdjustment,
    totalProjectVatAdjusted,
    totalPriceProjectWithVatAdjusted,
  } = props;

  return (
    <div
      className={cx(
        mainStyles['LandingPage'],
        styles['Bdc'],
        mainStyles['pages-container'],
      )}
    >
      {!isSignature && (
        <Button
          style={{ position: 'fixed', top: '10px', left: '10px' }}
          type={BtnType.LINEAR}
          level={BtnLevel.SECONDARY}
          onClick={() => triggerUpsells()}
        >
          Appliquer Upsell
          <br />
          sans signature
        </Button>
      )}

      {/* PAGE 1 et + */}
      {itemPages.map((itemPage: any, pageIdx: number) => (
        <div
          className={cx(
            mainStyles['LandingPage-page'],
            templateStyles['Template'],
            styles['page'],
            styles[`page-${pageIdx + 1}`],
          )}
          key={pageIdx}
        >
          {/* EN TETE DE PREMIER PAGE */}
          <div>
            {pageIdx === 0 && (
              <>
                {/* Titre */}
                <div className={cx(templateStyles['Template-head'])}>
                  {isKit ? (
                    <img
                      src={gekaLogoGreen_nobg_png}
                      style={{ marginTop: '-40px' }}
                      alt="Logo Greenkub"
                    />
                  ) : (
                    <Icon name={IconEnum.LOGO} width={'230'} />
                  )}
                  <h1>
                    Avenant au BDC <span>{project.quotation}</span>
                  </h1>
                </div>

                <div className={styles['Bdc-project']}>
                  <ul className={styles['Bdc-greenkub']}>
                    <li>
                      Projet&nbsp;: <span>{project.id}</span>
                    </li>
                    <li>
                      Date&nbsp;:{' '}
                      <span>
                        {DateTime.now().toLocaleString()}
                      </span>
                    </li>
                    <li>
                      Designer d'Espace&nbsp;:{' '}
                      <span>
                        {project.sales.firstName} {project.sales.lastName}
                      </span>
                    </li>
                    <li>
                      Email&nbsp;: <span>{project.sales.email}</span>
                    </li>
                    <li>
                      Téléphone&nbsp;:{' '}
                      <span>
                        {project.sales.phone
                          ? project.sales.phone
                          : project.sales.mobile}
                      </span>
                    </li>
                  </ul>

                  <div className={styles['Bdc-client']}>
                    <AddressPdfBloc project={project} />
                  </div>
                </div>
              </>
            )}

            {/* DONNES BDC */}
            <div className={styles['Bdc-tables']}>
              {itemPage.length > 0 && (
                <table className={styles['Bdc-products']}>
                  <thead>
                  <tr>
                    <th>Désignation</th>
                    <th>Prix HT</th>
                    <th>Qté</th>
                    <th>Total HT</th>
                  </tr>
                  </thead>
                  <tbody>
                  {itemPage.map((item, idx) => (
                    <tr key={idx}>
                      <td>
                        <strong>{item.name}</strong>
                        <p>{item.description}</p>
                        {item.description2 && <p>{item.description2}</p>}
                        {item.description3 && <p>{item.description3}</p>}
                      </td>
                      <td>{formatCurrency(item.unitPrice)}</td>
                      <td>{item.quantity ? item.quantity : 1}</td>
                      <td>{formatCurrency(item.totalPrice)}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              )}

              {pageIdx === itemPages.length - 1 && (
                <table className={styles['Bdc-totals']}>
                  <tbody>
                  <tr>
                    <th>Sous-total</th>
                    <td>{formatCurrency(totalPrice)}</td>
                  </tr>
                  <tr>
                    <th>Ajustement HT</th>
                    <td>
                      {isSignature ? (
                        formatCurrency(adjustment ? adjustment : 0)
                      ) : (
                        <GKToggleableInput
                          value={
                            adjustment
                              ? adjustment.toFixed(2).toString()
                              : '0'
                          }
                          onChange={(value) =>
                            updateAdjustment(parseFloat(value))
                          }
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>TVA</th>
                    <td>{formatCurrency(totalVatAdjusted)}</td>
                  </tr>
                  <tr>
                    <th>Total TTC</th>
                    <td>{formatCurrency(totalPriceWithVatAdjusted)}</td>
                  </tr>
                  </tbody>
                </table>
              )}
            </div>

            {/* FOOTER */}
            {pageIdx === itemPages.length - 1 && itemPage.length < 11 && (
              <>
                <div
                  className={cx(
                    templateStyles['Template-middle'],
                    styles['Amendment-middle'],
                  )}
                  style={{ marginTop: 0 }}
                >
                  <div
                    className={cx(
                      templateStyles['Template-comment'],
                      styles['Bdc-comment'],
                    )}
                  >
                    <span>Remarques&nbsp;:</span>
                    {isSignature ? (
                      <div className={styles['Bdc-comment-area']}>
                        {comment}
                      </div>
                    ) : (
                      <textarea
                        rows={8}
                        value={comment}
                        onChange={(e) => setComment(e.currentTarget.value)}
                      />
                    )}
                  </div>

                  <div className={styles['Bdc-signature']}>
                    <span>Signature</span>

                    {isSignature &&
                      project &&
                      (signatures[0] === true ? (
                        <p
                          className={cx(
                            templateStyles['Template-signed'],
                            styles['Bdc-signed'],
                          )}
                        >
                          {signature}
                        </p>
                      ) : (
                        <div
                          ref={sign1Ref}
                          style={{ zIndex: '9999' }}
                          className={cx(
                            templateStyles['Template-signatureBox'],
                            styles['Bdc-signatureBox'],
                            signatures[0] === 'pulse' && 'pulse',
                          )}
                          onClick={() => {
                            handleOpenModalSignHandler(0);
                          }}
                        >
                          <span>Cliquez ici pour apposer votre signature</span>
                        </div>
                      ))}
                  </div>
                </div>

                {/* MENTION */}
                <div className={styles['Bdc-mentions']}>
                  <div className={styles['Bdc-infos']}>
                    {!isKit && (
                      <>
                        <p>
                          <span>Faculté de renonciation</span>&nbsp;: Le client
                          a la faculté de renoncer au contrat qu'il vient de
                          souscrire conformément aux conditions générales de
                          ventes en annexe.
                        </p>
                        <p>
                          <span>Délais d'installation</span>&nbsp;: La société
                          Greenkub s'engage à procéder à l'installation des
                          produits contractés dans les 24 semaines à compter de
                          la validation de l'Avant Projet Définitif (APD). Sauf
                          dans l'hypothèse d'un retard résultant d'un cas prévu
                          aux articles 7 et 14 des conditions générales de vente
                          ci-jointe
                        </p>
                      </>
                    )}
                    {isKit ? (
                      <p>
                        <span>Conditions de règlement</span>&nbsp;: Dépôt de
                        garantie&nbsp;: 10% &bull; Production des
                        marchandises&nbsp;: 40% &bull; Expédition des
                        marchandises&nbsp;: 50% &bull; Pourcentages basés sur le
                        prix hors remise et ajustement. Toutes les remises et
                        ajustements seront déduits de la 3ème échéance.
                      </p>
                    ) : (
                      <p>
                        <span>Conditions de règlement</span>&nbsp;: Dépôt de
                        garantie&nbsp;: 10% &bull; Acceptation du projet par la
                        mairie&nbsp;: 40% &bull; Expédition des
                        marchandises&nbsp;: 40% &bull; Installation&nbsp;: 10%.
                        Pourcentages basés sur le prix hors remise et
                        ajustement. Toutes les remises et ajustements seront
                        déduits de la 4ème et dernière échéance.
                      </p>
                    )}
                  </div>
                  <div
                    className={styles['Bdc-foot']}
                    style={{ textAlign: 'center' }}
                  >
                    {isKit ? (
                      <>
                        <p>
                          COVER GREEN SAS - RCS N° 901159418 au capital de 10
                          000 Euros - TVA N° FR93901159418
                        </p>
                        <p>
                          300 avenue de la Royale - 34160 Castries - Tel&nbsp;:
                          09 74 59 41 72
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          SAS Greenkub - RCS N° 798802377 au capital de 1 249
                          731,29 Euros - TVA N° FR27798802377
                        </p>
                        <p>
                          300 Avenue de la Royale 34160 Castries - France -
                          Tel&nbsp;: 09 74 59 41 72
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ))}

      {itemPages[itemPages.length - 1].length >= 11 && (
        <div
          className={cx(
            mainStyles['LandingPage-page'],
            templateStyles['Template'],
            styles['page'],
            styles[`page-${itemPages.length + 1}`],
          )}
        >
          {/* EN TETE DE PREMIER PAGE */}
          <div>
            {/* FOOTER */}
            <div
              className={cx(
                templateStyles['Template-middle'],
                styles['Amendment-middle'],
              )}
              style={{ marginTop: 0 }}
            >
              <div
                className={cx(
                  templateStyles['Template-comment'],
                  styles['Bdc-comment'],
                )}
              >
                <span>Remarques&nbsp;:</span>
                {isSignature ? (
                  <div className={styles['Bdc-comment-area']}>{comment}</div>
                ) : (
                  <textarea
                    rows={8}
                    value={comment}
                    onChange={(e) => setComment(e.currentTarget.value)}
                  />
                )}
              </div>

              <div className={styles['Bdc-signature']}>
                <span>Signature</span>

                {isSignature &&
                  project &&
                  (signatures[0] === true ? (
                    <p
                      className={cx(
                        templateStyles['Template-signed'],
                        styles['Bdc-signed'],
                      )}
                    >
                      {signature}
                    </p>
                  ) : (
                    <div
                      ref={sign1Ref}
                      style={{ zIndex: '9999' }}
                      className={cx(
                        templateStyles['Template-signatureBox'],
                        styles['Bdc-signatureBox'],
                        signatures[0] === 'pulse' && 'pulse',
                      )}
                      onClick={() => {
                        handleOpenModalSignHandler(0);
                      }}
                    >
                      <span>Cliquez ici pour apposer votre signature</span>
                    </div>
                  ))}
              </div>
            </div>

            {/* MENTION */}
            <div
              className={styles['Bdc-mentions']}
              style={{ position: 'unset' }}
            >
              {!isKit && (
                <div className={styles['Bdc-infos']}>
                  <p>
                    <span>Faculté de renonciation</span>&nbsp;: Le client a la
                    faculté de renoncer au contrat qu'il vient de souscrire
                    conformément aux conditions générales de ventes en annexe.
                  </p>
                  <p>
                    <span>Délais d'installation</span>&nbsp;: La société
                    Greenkub s'engage à procéder à l'installation des produits
                    contractés dans les 24 semaines à compter de la validation
                    de l'Avant Projet Définitif (APD). Sauf dans l'hypothèse
                    d'un retard résultant d'un cas prévu aux articles 7 et 14
                    des conditions générales de vente ci-jointe
                  </p>
                </div>
              )}
              {isKit ? (
                <p>
                  <span>Conditions de règlement</span>&nbsp;: Dépôt de
                  garantie&nbsp;: 10% &bull; Production des marchandises&nbsp;:
                  40% &bull; Expédition des marchandises&nbsp;: 50% &bull;
                  Pourcentages basés sur le prix hors remise et ajustement.
                  Toutes les remises et ajustements seront déduites de la 3ème
                  échéance.
                </p>
              ) : (
                <p>
                  <span>Conditions de règlement</span>&nbsp;: Dépôt de
                  garantie&nbsp;: 10% &bull; Acceptation du projet par la
                  mairie&nbsp;: 40% &bull; Expédition des marchandises&nbsp;:
                  40% &bull; Installation&nbsp;: 10%. Pourcentages basés sur le
                  prix hors remise et ajustement. Toutes les remises et
                  ajustements seront déduits de la 4ème et dernière échéance.
                </p>
              )}
              <div
                className={styles['Bdc-foot']}
                style={{ textAlign: 'center' }}
              >
                {isKit ? (
                  <>
                    <p>
                      COVER GREEN SAS - RCS N° 901159418 au capital de 10 000
                      Euros - TVA N° FR93901159418
                    </p>
                    <p>
                      300 avenue de la Royale - 34160 Castries - Tel&nbsp;: 09
                      74 59 41 72
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      SAS Greenkub - RCS N° 798802377 au capital de 1 249 731,29
                      Euros - TVA N° FR27798802377
                    </p>
                    <p>
                      300 Avenue de la Royale 34160 Castries - France -
                      Tel&nbsp;: 09 74 59 41 72
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PAGE 2 et + */}
      {paginatedBDCAfterAvenant.map((itemPage, pageIdx) => (
        <div
          className={cx(
            mainStyles['LandingPage-page'],
            templateStyles['Template'],
            styles['page'],
            styles[`page-${pageIdx + 2}`],
          )}
          key={pageIdx}
        >
          <div>
            {pageIdx === 0 && (
              <>
                {/* Titre */}
                <div className={styles['Bdc-head']}>
                  {isKit ? (
                    <img
                      src={gekaLogoGreen_nobg_png}
                      style={{ marginTop: '-40px' }}
                      alt="Logo Greenkub"
                    />
                  ) : (
                    <Icon name={IconEnum.LOGO} width={'230'} />
                  )}

                  <h1>Bon de commande après avenant</h1>
                </div>

                {/* EN TETE */}
                <div className={styles['Bdc-project']}>
                  <ul className={styles['Bdc-greenkub']}>
                    <li>
                      Projet&nbsp;: <span>{project.id}</span>
                    </li>
                    <li>
                      Date&nbsp;:{' '}
                      <span>
                        {DateTime.now().toLocaleString()}
                      </span>
                    </li>
                    {project && (
                      <li>
                        Designer d'Espace&nbsp;:{' '}
                        <span>
                          {project.sales.firstName} {project.sales.lastName}
                        </span>
                      </li>
                    )}
                    {project && (
                      <li>
                        Email&nbsp;: <span>{project.sales.email}</span>
                      </li>
                    )}
                    {project && (
                      <li>
                        Téléphone&nbsp;: <span>09 74 59 41 72</span>
                      </li>
                    )}
                  </ul>

                  {/* EN TETE CLIENT */}
                  <div className={styles['Bdc-client']}>
                    <AddressPdfBloc project={project} />
                  </div>
                </div>
              </>
            )}

            {/* DONNEES BDC (après avenant ?)  */}
            <div className={styles['Bdc-tables']}>
              {itemPage.length > 0 && (
                <table className={styles['Bdc-products']}>
                  <thead>
                  <tr>
                    <th>Désignation</th>
                    <th>Prix HT</th>
                    <th>Qté</th>
                    <th>Total HT</th>
                  </tr>
                  </thead>
                  <tbody>
                  {itemPage.map((item, idx) => (
                    <tr key={idx}>
                      <td>
                        <strong>{item.name}</strong>
                        {item.description && <p>{item.description}</p>}
                        {item.description2 && <p>{item.description2}</p>}
                        {item.description3 && <p>{item.description3}</p>}
                      </td>
                      <td>{formatCurrency(item.unitPrice)}</td>
                      <td>{item.quantity ? item.quantity : 1}</td>
                      <td>{formatCurrency(item.totalPrice)}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              )}

              {pageIdx === paginatedBDCAfterAvenant.length - 1 && (
                <table className={styles['Bdc-totals']}>
                  <tbody>
                  <tr>
                    <th>Sous-total</th>
                    <td>{formatCurrency(bdcAfterAvenant.totalPrice)}</td>
                  </tr>
                  <tr>
                    <th>Ajustement HT</th>
                    <td>{formatCurrency(projectAdjustment)}</td>
                  </tr>
                  <tr>
                    <th>TVA</th>
                    <td>{formatCurrency(totalProjectVatAdjusted)}</td>
                  </tr>
                  <tr>
                    <th>Total TTC</th>
                    <td>
                      {formatCurrency(totalPriceProjectWithVatAdjusted)}
                    </td>
                  </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      ))}

      {isKit ? (
        <>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={kit_bdcCGV1}
              alt="bdcCGV1"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={kit_bdcCGV2}
              alt="bdcCGV2"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={kit_bdcCGV3}
              alt="bdcCGV3"
            />
          </div>

          {/* EMPLACEMENT DE SIGNATURE */}
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={kit_bdcCGV4}
              alt="bdcCGV4"
            />
            <div className={styles['Bdc-bdc-signature']}>
              {isSignature &&
                project &&
                (signatures[1] === true ? (
                  <p className={styles['Bdc-signed']}>{signature}</p>
                ) : (
                  <div
                    ref={sign2Ref}
                    style={{ zIndex: '9999' }}
                    className={cx(
                      templateStyles['Template-signatureBox'],
                      // styles['MandatGestion-signed'],
                      styles['Bdc-signatureBox'],
                      signatures[0] === 'pulse' && styles['pulse'],
                    )}
                    onClick={() => {
                      handleOpenModalSignHandler(1);
                    }}
                  >
                    <span>
                      Cliquez ici pour apposer
                      <br /> votre signature
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV1}
              alt="bdcCGV1"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV2}
              alt="bdcCGV2"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV3}
              alt="bdcCGV3"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV4}
              alt="bdcCGV4"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV5}
              alt="bdcCGV5"
            />
          </div>
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV6}
              alt="bdcCGV6"
            />
          </div>

          {/* EMPLACEMENT DE SIGNATURE */}
          <div
            className={cx(
              mainStyles['LandingPage-page'],
              templateStyles['Template'],
              styles['page'],
              styles['void'],
            )}
          >
            <img
              className={styles['full-picture']}
              src={bdcCGV7}
              alt="bdcCGV7"
            />
            <div className={styles['Bdc-bdc-signature']}>
              {isSignature &&
                project &&
                (signatures[1] === true ? (
                  <p className={styles['Bdc-signed']}>{signature}</p>
                ) : (
                  <div
                    ref={sign2Ref}
                    className={cx(
                      templateStyles['Template-signatureBox'],
                      // styles['MandatGestion-signed'],
                      styles['Bdc-signatureBox'],
                      signatures[0] === 'pulse' && styles['pulse'],
                    )}
                    onClick={() => {
                      handleOpenModalSignHandler(1);
                    }}
                  >
                    <span>
                      Cliquez ici pour apposer
                      <br /> votre signature
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Amendment;
